<nav class="navbar navbar-vertical navbar-expand-md navbar-light bg-white" id="sidenav-main">
  <div class="container-fluid">
    <!-- Toggler -->
    <button class="navbar-toggler" type="button" (click)="isCollapsed=!isCollapsed"
      aria-controls="sidenav-collapse-main">
      <span class="navbar-toggler-icon"></span>
    </button>


    <ul class="nav align-items-center d-md-none" *ngIf="is_connected">
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <div class="nav-link">
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Image placeholder" [src]="avatar">
            </span>
          </div>
        </div>
      </li>
    </ul>

    <!-- Collapse -->
    <div class="collapse navbar-collapse" [ngbCollapse]="isCollapsed" id="sidenav-collapse-main">
      <!-- Collapse header -->
      <div class="collapse-brand d-md-block d-none text-center mb-2" *ngIf="is_connected">
        <div class="nav-link">
          <span class="avatar avatar-xxl rounded-circle">
            <img alt="Image placeholder" [src]="avatar">
          </span>
        </div>
      </div>
      <div class="navbar-collapse-header d-md-none">
        <div class="row">
          <!-- close button -->
          <div class="collapse-close" [ngClass]="{'col-2':is_connected,'col-12':!is_connected}">
            <button type="button" class="navbar-toggler" (click)="isCollapsed=!isCollapsed">
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      <!-- Navigation -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <button class="btn btn-studiomap w-100 my-2" *ngIf="is_connected && currentUser.role == 'manager_studio' && title_btn_switch != ''" (click)="btn_switch_role()">{{ title_btn_switch }}</button>
        </li>
        <li *ngFor="let menuItem of menuItems" class="{{menuItem.class}} nav-item">
          <a routerLinkActive="active" (click)="menuItem.action()" class="nav-link pointer">
            <i class="ni {{menuItem.icon}}"></i>
            {{menuItem.title}}
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>